import { useState } from "react";
import ImportData from "@components/Vendors/popup/importdata";
import DataImported from "@components/Vendors/popup/DataImported";

export default function ImportDataPopup(props: any) {
	const { isDataImported } = props;
	return (
		<section className="popup-wrapper d-flex">
			{!isDataImported && (
				<ImportData
					handleUpload={props.handleUpload}
					handleChangeUpload={props.handleChangeUpload}
					importedSuccessfully={props.importedSuccessfully}
					closePopup={() => {
						props.closePopup();
					}}
					importedFile={props.importedFile}
					setImportTedFile={props.setImportTedFile}
					handleDownload={props.handleDownload}
					submitLoading={props.submitLoading}
				/>
			)}
			{isDataImported && (
				<DataImported
					closePopup={() => {
						props.closePopup();
					}}
					response={props.response}
				/>
			)}
		</section>
	);
}
